import React from 'react';
import { View } from 'react-native';
import { SkeletonBone } from '../SkeletonBone';

interface SkeletonTextBlockProps {
  lines?: number;
  lastLineWidth?: number | `${number}%`;
  lineHeight?: number;
  gap?: number;
}

export const SkeletonTextBlock: React.FC<SkeletonTextBlockProps> = React.memo(({
  lines = 3,
  lastLineWidth = '60%',
  lineHeight = 14,
  gap = 6,
}) => (
  <View style={{ gap }}>
    {Array.from({ length: lines }).map((_, i) => (
      <SkeletonBone
        key={i}
        width={i === lines - 1 ? lastLineWidth : '100%'}
        height={lineHeight}
      />
    ))}
  </View>
));

SkeletonTextBlock.displayName = 'SkeletonTextBlock';
